import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePage } from "../../hooks/usePage";
import { Loading, PageHero, RichText } from "../../components/site/Blocks";
import { api, mediaSrc } from "../../lib/api";
import { shortDate } from "../../lib/format";

export function NewsList() {
  const { section, loading } = usePage("news");
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/public/news").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (loading) return <Loading />;
  const intro = section("intro");
  return (
    <div data-testid="news-page">
      {intro && <PageHero eyebrow={intro.eyebrow} title={intro.heading} subtitle={intro.body} />}
      <section className="container-site py-16">
        {items?.length === 0 && <p className="text-lg text-[#4A5568]">No news yet.</p>}
        <ul className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {(items || []).map((n) => (
            <li key={n.id} className="overflow-hidden rounded-lg border border-slate-200" data-testid={`news-card-${n.slug}`}>
              {n.image_url && <img src={mediaSrc(n.image_url)} alt="" className="aspect-[16/9] w-full object-cover" />}
              <div className="p-6">
                <p className="text-sm text-[#4A5568]">{shortDate(n.published_at)}</p>
                <h2 className="mt-2 text-xl text-navy">{n.title}</h2>
                <p className="mt-2 text-[#4A5568]">{n.excerpt}</p>
                <Link to={`/news/${n.slug}`} className="mt-4 inline-block font-semibold text-burgundy underline-offset-4 hover:underline" data-testid={`news-read-${n.slug}`}>
                  Read more<span className="sr-only">: {n.title}</span>
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export function NewsDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(undefined);
  useEffect(() => { api.get(`/public/news/${slug}`).then((r) => setItem(r.data)).catch(() => setItem(null)); }, [slug]);
  if (item === undefined) return <Loading />;
  if (item === null) return <div className="container-site py-24" data-testid="news-not-found"><h1 className="text-3xl text-navy">Article not found</h1><Link to="/news" className="btn-outline mt-6">Back to news</Link></div>;
  return (
    <article data-testid="news-detail">
      <PageHero eyebrow={shortDate(item.published_at)} title={item.title} image={item.image_url} />
      <div className="container-site max-w-3xl py-14">
        <RichText html={item.body} />
        <Link to="/news" className="mt-8 inline-flex items-center gap-2 font-semibold text-burgundy" data-testid="news-back-link"><ArrowLeft size={18} aria-hidden="true" /> All news</Link>
      </div>
    </article>
  );
}
